import { render, staticRenderFns } from "./jzuni_order_detail.vue?vue&type=template&id=c8ff716a&scoped=true&"
import script from "./jzuni_order_detail.vue?vue&type=script&lang=js&"
export * from "./jzuni_order_detail.vue?vue&type=script&lang=js&"
import style0 from "./jzuni_order_detail.vue?vue&type=style&index=0&id=c8ff716a&lang=scss&scoped=true&"
import style1 from "./jzuni_order_detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ff716a",
  null
  
)

export default component.exports